<template>
  <div class="dashboard-statistics">
    <div class="row">
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 graph-col">
        <CalendarActivityTab 
          :metric="sessionMetrics.TIME_ABOVE_80_PERCENT_HR"
          :chart-value="formattedHrValue"
          :currentMetric="currentMetric"
          :changeSelectedMetric="changeSelectedMetric"
        />
      </div>
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 graph-col">
        <CalendarActivityTab 
          :metric="sessionMetrics.AP"
          :chart-value="summary.activeParticipation"
          :currentMetric="currentMetric"
          :changeSelectedMetric="changeSelectedMetric"
        />
      </div>
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 graph-col">
        <CalendarActivityTab 
          :metric="sessionMetrics.WORKLOAD"
          :chart-value="Math.round(summary.workload)"
          :currentMetric="currentMetric"
          :changeSelectedMetric="changeSelectedMetric"
        />
      </div>
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 graph-col">
        <CalendarActivityTab 
          :metric="sessionMetrics.DISTANCE"
          :chart-value="summary.distance"
          :currentMetric="currentMetric"
          :changeSelectedMetric="changeSelectedMetric"
        />
      </div>
    </div>

    <div 
      :class="{ 
        'red':    sessionMetrics.TIME_ABOVE_80_PERCENT_HR ===  currentMetric,
        'yellow': sessionMetrics.AP ===  currentMetric,
        'blue':    sessionMetrics.DISTANCE ===  currentMetric,
        'purple':    sessionMetrics.WORKLOAD ===  currentMetric,
      }"
      class="statistic-border"></div>
  </div>
</template>

<script>
import CalendarActivityTab from '@/components/calendar-activity/CalendarActivityTab'
import { SESSION_METRICS } from '@/constants/SessionConsts'

export default {
  name: 'CalendarActivityTabs',
  props: [
    'summary',
    'currentMetric',
    'changeSelectedMetric'
  ],
  data () {
    return {
      hrFullCircleValue: 45,
      apFullCircleValue: 60,
      distanceFullCircleValue: 7500,
      speedFullCircleValue: 30,
      sessionMetrics: SESSION_METRICS
    }
  },
  computed: {
    formattedHrValue () {
      if (this.summary.timeAbove80PercentHrSeconds === null) {
        return null
      }

      return this.$options.filters.secondsToMinutes(this.summary.timeAbove80PercentHrSeconds)
    }
  },
  components: {
    CalendarActivityTab
  }
}
</script>

<style lang="scss" scoped>
  .statistic-border {
    height: 3px;
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
    margin-top: 50px;

    &.red {
      background-color: $flush-mahogany;
      transition: all .8s;
    }

    &.yellow {
      background-color: $luxor-gold;
      transition: all .8s;
    }

    &.blue {
      background-color: $calipso;
      transition: all .8s;
    }

    &.purple {
      background-color: $electric-violet;
      transition: all .8s;
    }
  }
</style>
